export const allowedEmails = [
  'estating.com',
  'techrivo.com'
];